const AddressSuggestionQueryKeys = {
  global: ["addressSuggestions"] as const,
  fromInput: (input: string) =>
    [...AddressSuggestionQueryKeys.global, "input", input] as const,
};

export { AddressSuggestionQueryKeys };
